"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpSidebar = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
require("./styles.scss");
const sidebar_html_1 = __importDefault(require("./sidebar.html"));
const interactjs_1 = __importDefault(require("interactjs"));
const RESIZE_HANDLE = '.itp-sidebar__resize-handle';
let ItpSidebar = class ItpSidebar extends vue_1.default {
    isCollapsed;
    previousWidth;
    width;
    toggleOnResizeTolerance;
    defaultWidth;
    collapsedWidth;
    scrollY;
    data() {
        return {
            previousWidth: null,
            width: this.defaultWidth,
            isCollapsed: false
        };
    }
    mounted() {
        const interactable = (0, interactjs_1.default)(this.$el)
            .resizable({
            edges: {
                top: false,
                right: RESIZE_HANDLE,
                bottom: false,
                left: false
            }
        })
            .on(['resizemove'], _.throttle(ev => this.onResize(ev), 100))
            .on(['resizeend'], ev => this.onResizeEnd(ev));
    }
    get minWidth() {
        return this.collapsedWidth;
    }
    get sidebarStyle() {
        return {
            'min-width': `${this.minWidth}px`,
            width: `${this.width}px`
        };
    }
    get contentStyle() {
        if (!this.isCollapsed) {
            return {
                'overflow-y': this.scrollY ? 'scroll' : 'none'
            };
        }
        return {
            width: this.collapsedWidth,
            visibility: 'hidden'
        };
    }
    get iconClass() {
        return this.isCollapsed
            ? 'fas fa-angle-double-right'
            : 'fas fa-angle-double-left';
    }
    get sidebarClass() {
        return [this.isCollapsed ? 'collapsed' : 'expanded'];
    }
    onResize(ev) {
        let currentWidth = ev.rect.width + 14;
        this.width = Math.max(this.minWidth, currentWidth);
        if (this.isCollapsed &&
            this.width > this.minWidth + this.toggleOnResizeTolerance) {
            this.isCollapsed = false;
        }
        else if (!this.isCollapsed &&
            this.width < this.minWidth + this.toggleOnResizeTolerance) {
            this.isCollapsed = true;
        }
    }
    onResizeEnd(ev) {
        if (this.width > this.minWidth + this.toggleOnResizeTolerance) {
            this.isCollapsed = false;
        }
        else if (this.width < this.minWidth + this.toggleOnResizeTolerance) {
            this.width = this.minWidth;
            this.isCollapsed = true;
        }
    }
    onMouseLeave() { }
    onMouseEnter() { }
    toggle() {
        this.isCollapsed = !this.isCollapsed;
        const w = this.width;
        this.width = this.isCollapsed ? this.collapsedWidth : this.previousWidth;
        if (this.isCollapsed) {
            this.previousWidth = w;
        }
        this.$emit('sidebar:toggle', this.isCollapsed);
    }
};
exports.ItpSidebar = ItpSidebar;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 50 }),
    __metadata("design:type", Number)
], ItpSidebar.prototype, "toggleOnResizeTolerance", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 200 }),
    __metadata("design:type", Number)
], ItpSidebar.prototype, "defaultWidth", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 30 }),
    __metadata("design:type", Number)
], ItpSidebar.prototype, "collapsedWidth", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpSidebar.prototype, "scrollY", void 0);
exports.ItpSidebar = ItpSidebar = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: sidebar_html_1.default
    })
], ItpSidebar);
//# sourceMappingURL=sidebar.js.map